'use client'

import type { ReactElement } from 'react'
import { AppLayout } from '@/components/layouts/app-layout/app-layout'
import { ResetPasswordForm } from '@/components/forms/reset-password'

export default function ResetPasswordPage(): ReactElement {
    return (
        <AppLayout>
            <ResetPasswordForm />
        </AppLayout>
    )
}
